import React, { useState } from "react";
import { useSelector } from "react-redux";
import FaqModal from "./custom/FaqModal";
import { Card, Col, Container, Row } from "react-bootstrap";
import { formatMoney } from "@/utils/numCommas";
const BidDepositAmountFormInfo = ({ paymentFlag }) => {
  const [showFaqModal, setShowFaqModal] = useState(false);

  const selector = useSelector((state) => state?.bidwizardStage?.Stage);

  // console.log("selector", selector);
  const selectorAmount = useSelector(
    (state) => state?.bidwizardStage?.BidAmount
  );

  const { bidRequest, validationResult } = selector || {};
  const isChargeApplicable =
    (selectorAmount?.bidDepositChargeAmount != null &&
      selectorAmount?.isBidDepositChargeApplicable === "Y") ||
    (validationResult?.bidDepositChargeAmount != null &&
      validationResult?.isBidDepositChargeApplicable === "Y");
  const formatedAmount = formatMoney(validationResult?.bidDepositAmount);

  const formatedChargeAmount = formatMoney(
    validationResult?.bidDepositChargeAmount
  );
  // const totalFormatedAmount = formatMoney(
  //   validationResult?.bidDepositAmount +
  //     validationResult?.bidDepositChargeAmount
  // );
  const totalFormatedAmount = isChargeApplicable
    ? formatMoney(
        validationResult?.bidDepositAmount +
          validationResult?.bidDepositChargeAmount
      )
    : formatMoney(
        validationResult?.bidDepositAmount || selectorAmount?.bidDepositAmount,
        0
      );
  // console.log("totalFormatedAmount", totalFormatedAmount);

  // const selectorAmountFormatted = formatMoney(
  //   selectorAmount?.bidDepositAmount + selectorAmount?.bidDepositChargeAmount
  // );
  const selectorAmountFormatted = isChargeApplicable
    ? formatMoney(
        selectorAmount?.bidDepositAmount +
          selectorAmount?.bidDepositChargeAmount
      ) // with decimals
    : formatMoney(selectorAmount?.bidDepositAmount, 0); // no decimals

  const selectorFormatedAmount = formatMoney(selectorAmount?.bidDepositAmount);
  const selectorFormatedChargeAmount = formatMoney(
    selectorAmount?.bidDepositChargeAmount
  );
  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowFaqModal(true);
  };

  const handleCloseModal = () => {
    setShowFaqModal(false);
  };

  return (
    <Container fluid className="px-0 mb-3">
      <Row>
        <Col xs={12}>
          <Card className=" bid-deposit-card bidd-deposit-card-above-form ">
            <Card.Body>
              <p className="mb-4 bid-deposit-title-info">Bid Deposit</p>
              {/* <Row>
                <Col md={3}>
                  <h4 className="mb-3">Total Amount</h4>
                  <h3 className="mb-4">
                    <span className="text-success">
                      ${" "}
                      {(
                        validationResult?.bidDepositAmount +
                          validationResult?.bidDepositChargeAmount ||
                        selectorAmount?.bidDepositAmount +
                          selectorAmount?.bidDepositChargeAmount
                      )?.toLocaleString()}
                    </span>
                  </h3>
                </Col>

                <Col md={8}>
                  <div className="bid-deposit-text">
                    Bid deposit hold of ${" "}
                    {(
                      validationResult?.bidDepositAmount ||
                      selectorAmount?.bidDepositAmount
                    )?.toLocaleString()}{" "}
                    to be placed on your credit card. In order to verify funds,
                    there will be a one-time,{" "}
                    <strong>
                      non-refundable ${" "}
                      {validationResult?.bidDepositChargeAmount ||
                        selectorAmount?.bidDepositChargeAmount}{" "}
                      charge.
                    </strong>{" "}
                    For more information,
                    <div className="mt-2">
                      <a
                        href="#"
                        onClick={handleOpenModal}
                        className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                      >
                        please see our FAQs.
                      </a>
                    </div>
                  </div>
                  <FaqModal
                    show={showFaqModal}
                    handleClose={handleCloseModal}
                  />
                </Col>
              </Row> */}
              <Row className="BidDeposit_background p-2">
                <Col md={3} className="mt-4 vertical-divider">
                  <p className="text-center bidd-total-amount">Total Amount</p>
                  <p className="text-center mb-4">
                    <span className="text-success-amount">
                      $
                      {/* {(totalFormatedAmount === "0.00"
                        ? selectorAmountFormatted
                        : totalFormatedAmount
                      )?.toLocaleString()} */}
                      {paymentFlag
                        ? selectorAmount?.bidDepositAmount?.toLocaleString()
                        : (totalFormatedAmount !== "0.00" ||
                            selectorAmountFormatted !== "0.00") &&
                          (totalFormatedAmount !== "0.00"
                            ? totalFormatedAmount
                            : selectorAmountFormatted)}
                    </span>
                  </p>
                </Col>

                <Col md={8}>
                  <div className="bid-deposit-text-info">
                    Bid deposit hold of $
                    {/* {(formatedAmount === "0.00"
                      ? selectorFormatedAmount
                      : totalFormatedAmount
                    )?.toLocaleString()}{" "} */}
                    {paymentFlag
                      ? selectorAmount?.bidDepositAmount?.toLocaleString()
                      : formatedAmount === "0.00"
                      ? selectorFormatedAmount
                      : totalFormatedAmount}{" "}
                    to be placed on your credit card.
                    <br />
                    {isChargeApplicable && (
                      <>
                        {" "}
                        In order to verify funds, there will be a one-time,{" "}
                        <strong>
                          non-refundable $
                          {formatedChargeAmount === "0.00"
                            ? selectorFormatedChargeAmount
                            : formatedChargeAmount}{" "}
                          charge.
                        </strong>{" "}
                        For more information,
                        <div className="">
                          <a
                            href="#"
                            onClick={handleOpenModal}
                            className=" linkkk_bid link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline"
                          >
                            please see our FAQs.
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                  <FaqModal
                    show={showFaqModal}
                    handleClose={handleCloseModal}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BidDepositAmountFormInfo;
